<!-- PC端下载APP -->
<template>
  <div class="box">
    <!-- 蒙版 -->
    <div class="mask">
      <div class="topBox">
        <span @click="$router.push('/contactUs')">
          联系我们
        </span>
        <span style="margin-right:20px" @click="$router.push('/')">
          首页
        </span>
      </div>
      <div class="centerBox">
        <h1 class="logo"></h1>
        <h1 class="title">烟雨佳人 轻奢社交</h1>
        <!-- 描述 -->
        <div class="describe">
          每个人都有着对生活品质的一个追求，在这里你可以找寻到那个同你一样享受着完美生活品质的TA。每天自动给你推荐各地品质生活的TA，如果你觉得那个TA是你钟意的人，那么你可以发出邀请与TA一起完成一场完美的高品质约会。
        </div>
        <div class="downloadButtons">
          <!-- 下载按钮 -->
          <div class="downloadButton" @click="downloadMaskFlag=true">
            <svg t="1614335502792" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="3901" width="200" height="200">
              <path
                d="M639.872128 214.825175l0-43.945388-41.942058 0 0 43.945388 41.942058 0zM426.06993 214.825175l0-43.945388-41.942058 0 0 43.945388 41.942058 0zM661.866134 92.920413q105.878122 75.91342 105.878122 205.788878l-511.488511 0q0-131.878788 103.917416-205.788878l-55.965368-55.965368q-15.984016-15.984016 0-29.964702t29.964702 0l63.936064 63.936064q51.958708-27.961372 113.891442-27.961372 59.929404 0 111.888112 27.961372l63.936064-63.936064q15.984016-13.980686 29.964702 0t0 29.964702zM873.622378 342.697303q25.958042 0 44.968365 18.967699t18.967699 44.968365l0 297.686314q0 27.961372-18.967699 45.948718t-44.968365 17.987346-44.968365-17.987346-18.967699-45.948718l0-297.686314q0-25.958042 18.967699-44.968365t44.968365-18.967699zM150.377622 342.697303q25.958042 0 44.968365 18.967699t18.967699 44.968365l0 297.686314q0 27.961372-18.967699 45.948718t-44.968365 17.987346-44.968365-17.987346-18.967699-45.948718l0-297.686314q0-25.958042 18.967699-44.968365t44.968365-18.967699zM256.255744 768.255744l0-425.558442 511.488511 0 0 425.558442q0 17.987346-11.977356 29.964702t-29.964702 11.977356l-43.945388 0 0 149.866134q0 27.961372-18.967699 45.948718t-44.968365 17.987346-44.968365-17.987346-18.967699-45.948718l0-149.866134-83.92674 0 0 149.866134q0 27.961372-18.967699 45.948718t-44.968365 17.987346-44.968365-17.987346-18.967699-45.948718l0-149.866134-43.945388 0q-17.987346 0-29.964702-11.977356t-11.977356-29.964702z"
                p-id="3902"></path>
            </svg>
            Android
          </div>
          <!-- 下载按钮 -->
          <div class="downloadButton" @click="downloadMaskFlag=true" style="margin-left:30px">
            <svg t="1614335636304" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="5683" width="200" height="200">
              <path
                d="M791.488 544.095c-1.28-129.695 105.76-191.871 110.528-194.975-60.16-88.032-153.856-100.064-187.232-101.472-79.744-8.064-155.584 46.944-196.064 46.944-40.352 0-102.816-45.76-168.96-44.544-86.912 1.28-167.072 50.528-211.808 128.384-90.304 156.703-23.136 388.831 64.896 515.935 43.008 62.208 94.304 132.064 161.632 129.568 64.832-2.592 89.376-41.952 167.744-41.952s100.416 41.952 169.056 40.672c69.76-1.312 113.984-63.392 156.704-125.792 49.376-72.16 69.728-142.048 70.912-145.632-1.536-0.704-136.064-52.224-137.408-207.136zM662.56 163.52C698.304 120.16 722.432 60 715.84 0c-51.488 2.112-113.888 34.304-150.816 77.536-33.152 38.368-62.144 99.616-54.368 158.432 57.472 4.48 116.128-29.216 151.904-72.448z"
                p-id="5684"></path>
            </svg>
            AppStore
          </div>
          <!-- 二维码按钮 -->
          <div class="qrcodeButton" @mouseenter="qrcodeButtonFlag = true" @mouseleave="qrcodeButtonFlag = false">
            <svg t="1614564707408" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="2166" width="200" height="200">
              <path
                d="M275.249633 16.445242 95.390056 16.445242c-52.346274 0-94.780898 42.435631-94.780898 94.780898l0 179.859577c0 52.34426 42.435631 94.780898 94.780898 94.780898l179.859577 0c52.345267 0 94.780898-42.436638 94.780898-94.780898L370.030531 111.22614C370.029524 58.879867 327.594899 16.445242 275.249633 16.445242zM269.278881 261.421251c0 13.086317-10.608404 23.695728-23.694721 23.695728L125.055528 285.116979c-13.087324 0-23.695728-10.609411-23.695728-23.695728L101.3598 140.89262c0-13.089337 10.609411-23.695728 23.695728-23.695728L245.58416 117.196892c13.087324 0 23.694721 10.606391 23.694721 23.695728L269.278881 261.421251z"
                p-id="2167"></path>
              <path
                d="M913.338715 16.445242l-179.857563 0c-52.346274 0-94.779891 42.435631-94.779891 94.780898l0 179.859577c0 52.34426 42.433618 94.780898 94.779891 94.780898l179.857563 0c52.346274 0 94.780898-42.436638 94.780898-94.780898L1008.119613 111.22614C1008.119613 58.879867 965.685996 16.445242 913.338715 16.445242zM907.371991 261.421251c0 13.086317-10.609411 23.695728-23.695728 23.695728L763.147632 285.116979c-13.087324 0-23.695728-10.609411-23.695728-23.695728L739.451904 140.89262c0-13.089337 10.608404-23.695728 23.695728-23.695728l120.527625 0c13.086317 0 23.695728 10.606391 23.695728 23.695728L907.370984 261.421251z"
                p-id="2168"></path>
              <path
                d="M275.249633 654.537345 95.390056 654.537345c-52.346274 0-94.780898 42.434625-94.780898 94.780898l0 179.859577c0 52.34426 42.435631 94.780898 94.780898 94.780898l179.859577 0c52.345267 0 94.780898-42.435631 94.780898-94.780898L370.030531 749.317236C370.029524 696.970963 327.594899 654.537345 275.249633 654.537345zM269.278881 899.511341c0 13.086317-10.608404 23.694721-23.694721 23.694721L125.055528 923.206062c-13.087324 0-23.695728-10.608404-23.695728-23.694721L101.3598 778.983716c0-13.08833 10.609411-23.695728 23.695728-23.695728L245.58416 755.287988c13.087324 0 23.694721 10.607398 23.694721 23.695728L269.278881 899.511341z"
                p-id="2169"></path>
              <path
                d="M913.338715 654.537345l-179.857563 0c-52.346274 0-94.779891 42.434625-94.779891 94.780898l0 179.859577c0 52.34426 42.433618 94.780898 94.779891 94.780898l179.857563 0c52.346274 0 94.780898-42.435631 94.780898-94.780898L1008.119613 749.317236C1008.119613 696.970963 965.685996 654.537345 913.338715 654.537345zM907.371991 899.511341c0 13.086317-10.609411 23.694721-23.695728 23.694721L763.147632 923.206062c-13.087324 0-23.695728-10.608404-23.695728-23.694721L739.451904 778.983716c0-13.08833 10.608404-23.695728 23.695728-23.695728l120.527625 0c13.086317 0 23.695728 10.607398 23.695728 23.695728L907.370984 899.511341z"
                p-id="2170"></path>
              <path
                d="M739.451904 453.035053 571.53383 453.035053 571.53383 83.611666c0-37.096189-30.073256-67.166424-67.169445-67.166424-37.095182 0-67.166424 30.071242-67.166424 67.166424l0 369.42238L67.778602 453.034046c-37.095182 0-67.167431 30.071242-67.167431 67.166424 0 37.094175 30.072249 67.169445 67.167431 67.169445l671.673301 0c37.095182 0 67.166424-30.07527 67.166424-67.169445C806.618328 483.105288 776.547086 453.035053 739.451904 453.035053z"
                p-id="2171"></path>
              <path
                d="M571.53383 956.790281c0 37.095182-30.073256 67.167431-67.169445 67.167431l0 0c-37.095182 0-67.166424-30.072249-67.166424-67.167431L437.197961 721.70679c0-37.097196 30.072249-67.169445 67.166424-67.169445l0 0c37.096189 0 67.169445 30.072249 67.169445 67.169445L571.53383 956.790281z"
                p-id="2172"></path>
              <path
                d="M1008.119613 520.201477c0 37.094175-30.069228 67.169445-67.165417 67.169445l0 0c-37.098202 0-67.167431-30.07527-67.167431-67.169445l0 0c0-37.096189 30.069228-67.166424 67.167431-67.166424l0 0C978.050385 453.035053 1008.119613 483.105288 1008.119613 520.201477L1008.119613 520.201477z"
                p-id="2173"></path>
            </svg>
            <!-- 二维码 -->
            <div id="qrcode2" class="qrcode" v-show="qrcodeButtonFlag">
            </div>
          </div>

        </div>

      </div>
      <!-- 底部 -->
      <div class="food">
        <p>2020-2021 © All Rights Reserved. 烟雨佳人APP&nbsp;&nbsp;湘ICP备2022026309号</p>
        <p>违法和不良信息举报邮箱：yyjrapp@163.com</p>
        <p><img src="..\assets\img\beianIcon.png" alt="" style="vertical-align: middle;"><a style="color: #b0aab3;"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21010402000369" target="_blank"
            rel="noopener noreferrer"> @百星文化</a></p>
      </div>
    </div>
    <!-- 下载遮罩 -->
    <div class="download-mask" v-show="downloadMaskFlag" @click="downloadMaskFlag=false">
      <div class="qrcodeBox">
        <div class="text">扫描二维码下载</div>
        <!-- 二维码 -->
        <div id="qrcode" class="qrcode"></div>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件 (比如：组件，工具js，第三方插件js，json文件，图片文件等等)
  // 例如：import 《组件名称》 from '《组件路径》'
  import QRCode from "qrcodejs2"; // 引入qrcode
  export default {
    name: "pcDownload",
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      // 这里存放数据
      return {
        // 下载遮罩开关
        downloadMaskFlag: false,
        // 二维码按钮开关
        qrcodeButtonFlag: false,
        // 二维码实例
        qrcode: null,
        qrcode2: null
      };
    },
    // 计算属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成 (可以访问当前this实例)
    created() {},
    // 生命周期 - 挂载完成 (可以访问DOM元素)
    mounted() {
      var _this = this;
      // 生成二维码
      this.$nextTick(function () {
        _this.qrcode = new QRCode("qrcode", {
          width: 190,
          height: 190,
          text: "https://yyjrapp.com/#/download", // 二维码内容 也可以放url
          colorDark: "#000",
          colorLight: "#fff"
        });
        _this.qrcode2 = new QRCode("qrcode2", {
          width: 200,
          height: 200,
          text: "https://yyjrapp.com/#/download", // 二维码内容 也可以放url
          colorDark: "#000",
          colorLight: "#fff"
        });
      });
    },
    // 生命周期 - 销毁之前
    beforeDestroy() {},
    // 生命周期 - 销毁完成
    destroyed() {},
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* @import url(路径); 引入公共css类 */
  .box {
    background-image: url(..\assets\img\pcBg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 100vh;
    min-width: 1000px;
    min-height: 850px;
  }

  .mask {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.472);
  }

  .topBox {
    position: absolute;
    width: 60%;
    top: 5%;
    left: 20%;
    font-size: 20px;
  }

  .topBox span {
    float: right;
    color: #fff;
    cursor: pointer;
  }

  .centerBox {
    position: absolute;
    top: 32%;
    margin-top: -150px;
    left: 20%;
    width: 600px;
    height: 300px;
    padding: 20px;
  }

  .centerBox .title {
    font-size: 60px;
    color: #fff;
    font-weight: normal;
    margin-bottom: 10px;
  }

  .centerBox .logo {
    height: 150px;
    width: 150px;
    background-image: url(..\assets\img\logo.png);
    background-size: 100%;
    border-radius: 15px;
    margin-bottom: 20px;
    margin-left: 163px;
  }

  .centerBox .describe {
    color: #fff;
    font-size: 24px;
  }

  /* 二维码 */
  .qrcode {
    display: inline-block;
    padding: 20px;
    background-color: #fff;
    border-radius: 6px;
  }

  @-webkit-keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }

    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
      transform: scale3d(1.05, 1.05, 1.05);
    }

    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

  @keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }

    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
      transform: scale3d(1.05, 1.05, 1.05);
    }

    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

  #qrcode2 {
    transition: all .3s;
    position: absolute;
    padding: 10px;
    top: 0px;
    left: 0px;
    animation-duration: 0.5s;
    animation-fill-mode: both;
    animation-name: pulse;
    z-index: 10;
  }



  .downloadButtons {
    margin-top: 20px;
    margin-left: 30px;
  }

  /* 下载按钮 */
  .downloadButton {
    display: inline-block;
    position: relative;
    padding: 10px 20px;
    background-color: #fff;
    border-radius: 10px;
    cursor: pointer;
    font-size: 20px;
    height: 35px;
    line-height: 35px;
    padding-left: 60px;
  }

  .downloadButton .icon {
    position: absolute;
    left: 25px;
    top: 13px;
    width: 25px;
    height: 25px;
  }

  /* 动画 */
  @-webkit-keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  /* 二维码按钮 */
  .qrcodeButton {
    position: relative;
    display: inline-block;
    height: 35px;
    background-color: #fff;
    vertical-align: bottom;
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
    margin-left: 30px;
  }

  .qrcodeButton svg {
    height: 35px;
    width: 35px;
  }


  /* 下载遮罩 */
  .download-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.472);
    animation-name: fadeIn;
    animation-duration: 1s;
    animation-fill-mode: both;
  }

  .download-mask .qrcodeBox {
    display: inline-block;
    position: absolute;
    left: 50%;
    margin-left: -115px;
    top: 50%;
    margin-top: -150px;
  }

  .download-mask .qrcodeBox .text {
    color: #fff;
    font-size: 32px;
    text-align: center;
    margin-bottom: 16px;
  }

  /* 底部 */
  .food {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 2%;
    color: #b0aab3;
    font-size: 14px;
  }
</style>


// WEBPACK FOOTER //
// src/components/pcDownload.vue